import * as React from "react";
import { PageContainer } from "#pages/PageContainer";
import { useAppSelector } from "#store";
import { useDispatch } from "react-redux";
import { ObjectTable } from "#common/ObjectTable";
import { H1 } from "#common/headings";
import { listActionsFromServer } from "#store/actions/actionActions";

export const ActionsListingPage = () => {
    const dispatch = useDispatch();
    const actions = useAppSelector(state => {
        const a = Object.values(state.actions.actions).map(
            ({ payload, ...rest }) => {
                const x: Record<string, unknown> = {
                    ...rest,
                    ...payload,
                };
                return x;
            }
        );
        return a;
    });

    React.useEffect(() => {
        dispatch(listActionsFromServer());
    }, []);

    return (
        <PageContainer>
            <H1>Actions</H1>
            <ObjectTable
                data={actions as unknown[] as Array<Record<string, unknown>>}
            />
        </PageContainer>
    );
};
